import { DB_DATE_FORMAT } from 'core/constants';
import { formatDateForServer } from 'core/utils';
import { IJob, IUpdateJobForm } from 'jobs/types';

export const mapUpdateJobForm = (data: IUpdateJobForm, jobs?: IJob[]) => {
  let bomData: Record<string, string | number | null> = {
    corporateBomStatusId: data?.status?.id,
    externalLocationRegion: data?.externalLocationRegion,
    externalLocationCountry: data?.externalLocationCountry?.name,
    customerNumber: data?.customerNumber,
    requestedByUserId: data?.requestedByUser?.userId,
    requestedByUserEmployeeId: data?.requestedByUserEmployeeId,
    supportUserId: data?.supportUser?.userId,
  };

  if (data?.supportCompletedDate) {
    bomData = {
      ...bomData,
      supportCompletedDate: formatDateForServer(data.supportCompletedDate, DB_DATE_FORMAT),
    };
  }

  return {
    boms: jobs.map((job) => ({
      id: job.id,
      projectId: job.projectId,
      ...bomData,
    })),
  };
};
